import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { StorageService } from '../_services/storage.service';
import { MetaService } from '@ngx-meta/core';
import { ApiService } from '../_services/api.service';
import { environment } from '../../../environments/environment';
import { LocalizeRouterService } from 'localize-router';
// tslint:disable: variable-name
export class SearchSchede {
  language;
  titolo;
  testo;
  dataDal;
  dataAl;
  categorie;
  sottocategorie;
  filtriComuni: number [];
  filtriSottocategoria: number [];
  filtriCategoria: number [];
  bollini;
  zone;
  macrozone;
  bwcard;
  prezzo_basso;
  prezzo_medio;
  prezzo_alto;
  idFornitore;
  orderBy = 'prezzo';
  orderType = 'asc';
  numRecordIniziale = 1;
  numRecordDaEstrarre = environment.schedePerPagina;
  soloMappa = false;
  zoneTrekksoft;
  categorieTrekksoft;
}

@Injectable()
export class CardListResolver implements Resolve<any> {

  constructor(private storage: StorageService, private meta: MetaService, private apiService: ApiService, private router: Router, private localize: LocalizeRouterService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    const language = state.url.split('/')[1];
    let slugCategoria: string = route.params.categoriaScheda;
    if (!slugCategoria) { slugCategoria = state.url.split('/')[2]; }
    console.log( 'CardListResolver -> ', language, ', ', slugCategoria, 'Query params', route.queryParams );

    const forUser = !slugCategoria.endsWith('-all');
    if (forUser) { this.meta.setTag('robots', 'noindex'); }
    slugCategoria = slugCategoria.replace('-all', '');

    const jsonIn = new SearchSchede();
    jsonIn.language = language;

    if (route.queryParams && route.queryParams.pag) {
      jsonIn.numRecordIniziale = (route.queryParams.pag - 1) * environment.schedePerPagina + 1;
    }

    return this.storage.getMappone(language).pipe(
      map(mappone => {

        const categoria = mappone.categorie.find(c => c.seo && c.seo.slug === slugCategoria);
        if ( !categoria) { this.router.navigate(['/' + language + '/404']); }

        this.meta.setTitle(categoria.seo.title);
        if ( categoria.seo.description) {
          this.meta.setTag('description', categoria.seo.description);
        }
        if (categoria.seo.keywords) {
          this.meta.setTag('keywords', categoria.seo.keywords);
        }
        jsonIn.categorie = [categoria.id];
        return {mappone, categoria};
      }), /*
      switchMap(({mappone, categoria}) => {
        return this.apiService.getSottocategorie({language, idCategoria: categoria.idCategoria}).pipe(
          map(sottocategorie => ({
            categoria,
            filtri: {
              macrozone: mappone.macrozone,
              zone: mappone.zone,
              bollini: mappone.mood,
              sottocategorie,
              filtri: mappone.filtri,
            }})
          )
        );
      }),*/
      switchMap(({categoria, mappone/*, filtri*/}) => this.apiService.schedaSearchSchede(jsonIn).pipe(map(schedeResponse => ({categoria, filtri: mappone.filtri, schedeResponse, jsonIn, forUser})) ))
    );
  }
}


